import * as THREE from 'three'
import EventEmitter from '../Utils/EventEmitter'
import Experience from '../Experience'
import gsap from 'gsap'


const pulseVertex = `varying vec2 vUv;
    void main() {
    vUv = uv; // Pass UV coordinates to the fragment shader
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }`

const pulseFragment = `
uniform float uTime;
uniform float uTransparent;
uniform vec3 uColor;
varying vec2 vUv;

void main() {
    // Calculate the distance from the center
    vec2 center = vec2(0.5, 0.5);
    float dist = distance(vUv, center);

    // Discard fragments outside the circle
    if (dist > 0.5) {
        discard;
    }

    // Circular wave parameters
    float waveWidth = 0.03; // Increased line thickness
    float speed = 1.0;      // Speed of wave propagation
    float frequency = 10.0;  // Number of waves
    float wave = abs(sin(frequency * dist - uTime * speed));

    // Create a thicker line effect
    float line = smoothstep(0.3 - waveWidth, 0.3, wave) - smoothstep(0.5, 0.5 + waveWidth, wave);
    line *= uTransparent;

    // Add fade-out effect for transparency
    float fade = 1.0 - smoothstep(0.4, 0.5, dist);
    // fade *= uTransparent;

    // Final color with transparency
    // vec3 color = vec3 (uColor);
    gl_FragColor = vec4(uColor, line * fade);
}

`


export default class IntPlane extends EventEmitter {
    constructor() {
        super()
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.time = this.experience.time
        this.regions = this.experience.regions
        this.intManager = this.experience.interactionManager
        this.interactiveGroup = new THREE.Group();
        this.scene.add(this.interactiveGroup)

        this.scaleTl = gsap.timeline({
            paused: true
        })
        // console.log(clonedMap)
        this.hoverMeshes = new THREE.Group()
        this.scene.add(this.hoverMeshes)

        this.dataViz = document.querySelector(".data-viz");
        this.activeRegion = document.querySelector(".region.active")

        this.dataVizTl = gsap.timeline({ paused: true })
            .from(this.dataViz, { autoAlpha: 0, opacity: 0, duration: 1.25, scale: 0.75, ease: 'power4.inOut' })

        this.regionCloseBtns = document.querySelectorAll(".regionClose")
        this.regionCloseBtns.forEach(closeBtn => {
            closeBtn.addEventListener("click", () => {
                this.dataVizClose()
            })
        })



        this.planeGeometry = new THREE.PlaneGeometry(1, 1, 32, 32);
        this.shaderMaterial = new THREE.ShaderMaterial({
            vertexShader: pulseVertex,
            fragmentShader: pulseFragment,
            uniforms: {
                uTime: { value: 0.0 },
                uTransparent: new THREE.Uniform(0.0),
                uColor: { value: new THREE.Color(0xffffff) },
            },
            // transparent: true,
            depthTest: false,
            blending: THREE.AdditiveBlending
        });


        this.shaderMaterial1 = new THREE.ShaderMaterial({
            vertexShader: pulseVertex,
            fragmentShader: pulseFragment,
            uniforms: {
                uTime: { value: 0.0 },
                uTransparent: new THREE.Uniform(0.0),
                uColor: { value: new THREE.Color(0x000000) }

            },
            // transparent: true,
            depthTest: false,
            blending: THREE.AdditiveBlending
        });



        this.setMesh()
    }

    setMesh() {

        for (const region of this.regions) {
            this.interactiveGroup.add(
                this.createMesh(region.reshort, region.position, region.name, region.countries)
            )
        }

        this.setInteractive()
        this.inputSearch()
    }

    createMesh(_name, position, countryName, countries) {


        const hoverGroup = new THREE.Group();
        hoverGroup.name = _name;
        hoverGroup.countryName = countryName
        hoverGroup.countries = countries
        hoverGroup.position.set(position.x, position.y, position.z)
        // Mesh
        const mesh = new THREE.Mesh(this.planeGeometry, this.shaderMaterial);
        hoverGroup.add(mesh)

        const hoverMesh = new THREE.Mesh(this.planeGeometry, this.shaderMaterial1)
        hoverMesh.visible = false
        hoverGroup.add(hoverMesh)

        return hoverGroup;

    }

    update() {
        if (this.shaderMaterial) {
            this.shaderMaterial.uniforms.uTime.value = this.time.elapsed * 0.002;
        }

        if (this.shaderMaterial1) {
            this.shaderMaterial1.uniforms.uTime.value = this.time.elapsed * 0.002;
        }
    }

    setInteractive() {

        this.scaleTl
            .to(this.interactiveGroup.children.map(c => c.scale), { x: 0, y: 0, z: 0, stagger: 0.05 })


        this.interactiveGroup.children.map((child, i) => {

            this.intManager.add(child)

            child.addEventListener('mouseover', (event) => {
                document.body.style.cursor = 'pointer';

                this.trigger('enter', [i, child.countryName, child.countries])
            });
            child.addEventListener('mouseout', (event) => {
                document.body.style.cursor = 'default';
                // gsap.to(".country__name",{opacity:0, autoAlpha:0})
            });
            child.addEventListener('mousedown', (event) => {
                // event.target.scale.set(1.1, 1.1, 1.1);
            });
            child.addEventListener('mouseup', (event) => {
                // event.target.scale.set(1.1, 1.1, 1.1);
                if (event.wasIntersectedOnMouseDown) {
                    // Object was intersected when mouse down fired, so this is essentially a click event
                } else {
                    // Object was not intersected when mouse down fired
                }
            });

            child.addEventListener('click', (event) => {

                this.trigger('clicked', [i, child.countryName, child.countries, child.name])
                gsap.to(this.experience.camera.controls.target, { duration: 1.25, ease: 'power4.inOut', y: child.position.y, x: child.position.x, z: child.position.z })
                gsap.to(this.experience.camera.instance.position, { z: 30, duration: 1.25, ease: 'power4.inOut' })
                // this.dataVizOpen(child.name)
            });
        })
    }

    inputSearch() {
        // const inputText = document.querySelector(".country__input--search")
        // const searchIcon = document.querySelector(".country__input--icon")
        // const countries = this.regions.map(region => region.countries.toLowerCase())
        // // searchIcon.addEventListener("click", (e) => {
        // //     e.preventDefault();
        // //     processInput()
        // // })

        // inputText.addEventListener("keydown", (e) => {
        //     if (e.key === 'Enter') {
        //         processInput()
        //     }
        // })

        // const processInput = () => {
        //     const searchCountry = inputText.value.toLowerCase().trim()

        //     for (let i = 0; i < countries.length; i++) {

        //         if (countries[i].includes(searchCountry)) {
        //             // this.trigger('enter', [i, this.regions[i].name, this.regions[i].countries])
        //             inputText.value = "";
        //         }
        //     }
        // }


    }


    hideHoverMeshes() {
        for (const mesh of this.hoverMeshes.children) {
            mesh.visible = false
        }

        for (const mesh of this.interactiveGroup.children) {
            mesh.visible = true
        }
    }


    dataVizOpen(_name) {

        console.log(`#region_${_name}`)

        document.querySelector(".regions.active").classList.remove("active")
        document.getElementById(`region_${_name}`).classList.add("active")

        this.dataVizTl.play()
    }

    dataVizClose() {
        this.dataVizTl.reverse()
    }


    play() {
        this.scaleTl.play()
    }

    reverse() {
        this.scaleTl.reverse()
    }




}
